<template>
    <SebraeTopbar v-if="$store.getters.isAutenticado">
        <template #start>
            <button type="button" class="sebrae-layout-btn sebrae-topbar__icon-btn" aria-label="Abrir menu" @click="onMenuButtonClick">
                <i class="pi pi-bars" aria-hidden="true"></i>
            </button>

            <router-link to="/" class="sebrae-layout-btn sebrae-topbar__brand">
                <img src="layout/images/logoSebrae.svg" alt="Sebrae" style="width: 80px; height: 80px" />
            </router-link>
        </template>

        <template #end>
            <BotaoTema />

            <TempoSessao v-if="!isMdOrSm" />

            <div class="sebrae-topbar__profile">
                <Avatar
                    :label="inicialUsuario"
                    shape="circle"
                    :aria-label="`Avatar de ${usuario?.nome || 'usuário'}`"
                />
                <div class="sebrae-topbar__profile-info">
                    <span class="sebrae-topbar__profile-name">{{ usuario.nome }}</span>
                    <span v-if="instituicao.sigla" class="sebrae-topbar__profile-role">{{ instituicao.sigla }}</span>
                </div>
            </div>

            <button type="button" class="sebrae-layout-btn sebrae-topbar__icon-btn" aria-label="Sair" title="Sair" @click="$store.dispatch('logout')">
                <i class="pi pi-sign-out" aria-hidden="true"></i>
            </button>
        </template>
    </SebraeTopbar>
</template>

<script>
import Avatar from 'primevue/avatar';
import TempoSessao from './app/auth/TempoSessao';
import BotaoTema from './shared/components/BotaoTema.vue';

export default {
    emits: ['menubutton-click', 'topbar-menubutton-click', 'topbar-item-click'],

    props: {
        topbarMenuActive: Boolean,
        activeTopbarItem: String,
    },

    components: {
        TempoSessao,
        Avatar,
        BotaoTema,
    },

    data() {
        return {
            windowWidth: window.innerWidth,
        };
    },

    computed: {
        usuario() {
            return this.$store.getters.usuario || {};
        },

        instituicao() {
            return this.$store.getters.instituicao || {};
        },

        isMdOrSm() {
            return this.windowWidth <= 376;
        },

        inicialUsuario() {
            const nome = (this.usuario?.nome || '').trim();
            if (!nome) return '?';
            const primeira = [...nome][0] || '?';
            return primeira.toLocaleUpperCase('pt-BR');
        },
    },

    mounted() {
        window.addEventListener('resize', this.handleResize);
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },

    methods: {
        handleResize() {
            this.windowWidth = window.innerWidth;
        },

        onMenuButtonClick(event) {
            this.$emit('menubutton-click', event);
        },
    },
};
</script>
